import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getPersonList as getPersonListApi,
	getPerson as getPersonApi,
	getPersonQuery as getPersonQueryApi,
	addNewPerson as addNewPersonApi,
	updatePerson as updatePersonApi,
	deletePerson as deletePersonApi,
	setPersonCancelled as setPersonCancelledApi,
	importPerson as importPersonApi,
} from '../../helpers/establishment/backend_helper';

export const getPersonList = createAsyncThunk(
	'persons/getPersonList',
	async () => {
		try {
			const response = getPersonListApi();
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getPersonQuery = createAsyncThunk(
	'persons/getPersonQuery',
	async params => {
		try {
			const response = getPersonQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getPerson = createAsyncThunk(
	'persons/getPerson',
	async person_id => {
		try {
			const response = getPersonApi(person_id);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

// export const setPersonCancelled = createAsyncThunk('persons/setPersonCancelled', async person_id => {
// 	try {
// 		const response = setPersonCancelledApi(person_id);
// 		return response;
// 	} catch (error) {
// 		throw new Error(error);
// 	}
// });

export const addNewPerson = createAsyncThunk(
	'persons/addNewPerson',
	async person => {
		try {
			const response = await addNewPersonApi(person);
			toast.success('Persona agregada exitosamente.', { autoClose: 3000 });
			return response;
		} catch (error) {
			// Extract error message from backend response
			const errorMessage =
				error?.response?.data?.message ||
				error?.message ||
				'Error al agregar persona';
			toast.error(errorMessage, { autoClose: 5000 });
			throw new Error(error);
		}
	}
);

export const updatePerson = createAsyncThunk(
	'persons/updatePerson',
	async person => {
		try {
			const response = await updatePersonApi(person);
			toast.success('Persona actualizada exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			// Extract error message from backend response
			const errorMessage =
				error?.response?.data?.message ||
				error?.message ||
				'Error al actualizar persona';
			toast.error(errorMessage, { autoClose: 5000 });
			throw new Error(error);
		}
	}
);

export const deletePerson = createAsyncThunk(
	'persons/deletePerson',
	async person => {
		try {
			const response = await deletePersonApi(person);
			toast.success('Persona eliminada exitosamente.', { autoClose: 3000 });
			return { person, ...response };
		} catch (error) {
			// Extract error message from backend response
			const errorMessage =
				error?.response?.data?.message ||
				error?.message ||
				'Error al eliminar persona';
			toast.error(errorMessage, { autoClose: 5000 });
			throw new Error(error);
		}
	}
);

export const importPerson = createAsyncThunk(
	'persons/importPerson',
	async data => {
		try {
			toast.info('Preparando la carga de las personas', { autoClose: 3000 });

			const response = await importPersonApi(data); // Esperamos la respuesta de la API

			// Verificamos que la respuesta contenga el mensaje esperado
			if (response?.message === 'Import completed successfully') {
				toast.success('Personas cargadas exitosamente', {
					autoClose: 3000,
				});
			} else {
				toast.error('Error en la carga de personas', { autoClose: 3000 });
			}

			return response;
		} catch (error) {
			toast.error('Error en la carga de personas', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);
